import { Component, lazy, Suspense } from "react";
import type { ReactNode } from "react";

const ParameterExplorer3D = lazy(() => import("./ParameterExplorer3D"));

interface ParameterExplorer3DLazyProps {
  studyId: string;
}

function Fallback() {
  return (
    <div className="h-[600px] flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto" />
        <p className="text-sm text-muted-foreground">
          Loading 3D parameter visualization...
        </p>
      </div>
    </div>
  );
}

/** Error boundary for WebGL/Plotly failures — shows a graceful fallback instead of crashing the page. */
class GL3DErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  render() {
    if (this.state.hasError) {
      return (
        <div className="h-[200px] flex items-center justify-center text-muted-foreground text-sm text-center px-4">
          3D visualization failed to load. Your browser or GPU may not support WebGL.
        </div>
      );
    }
    return this.props.children;
  }
}

export default function ParameterExplorer3DLazy({ studyId }: ParameterExplorer3DLazyProps) {
  return (
    <GL3DErrorBoundary>
      <Suspense fallback={<Fallback />}>
        <ParameterExplorer3D studyId={studyId} />
      </Suspense>
    </GL3DErrorBoundary>
  );
}
